/* eslint-disable no-undef */
(function (factory) {
    /* global define */
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(window.jQuery);
    }
}(($) => {
    // Extends plugins for adding hello.
    //  - plugin is external module for customizing.
    $.extend($.summernote.plugins, {
        /**
         * @param {Object} context - context object has status of editor.
         */
        rtl(context) {
            let selection;
            // ui has renders to build ui elements.
            //  - you can create a button with `ui.button`
            const ui = $.summernote.ui;
            // add hello button
            context.memo('button.rtl', () => {
                // create button
                const button = ui.button({
                    contents: '<i class="fa fa-paragraph"/><i class="fa fa-caret-left"/>',
                    tooltip: 'Change text direction to the right',
                    click() {
                        function clearSelection() {
                            if (document.selection) {
                                document.selection.empty();
                            } else if (window.getSelection) {
                                window.getSelection().removeAllRanges();
                            }
                        }

                        function getHTMLOfSelection() {
                            let range;
                            if (document.selection && document.selection.createRange) {
                                range = document.selection.createRange();
                                return range.htmlText;
                            } else if (window.getSelection) {
                                selection = window.getSelection();
                                if (selection.rangeCount > 0) {
                                    range = selection.getRangeAt(0);
                                    const clonedSelection = range.cloneContents();
                                    const div = document.createElement('div');
                                    div.appendChild(clonedSelection);
                                    return div.innerHTML;
                                }
                                return '';
                            }
                            return '';
                        }
                        const highlight = window.getSelection();
                        const range = highlight.getRangeAt(0);
                        const elementsClass = range.endContainer.parentElement;
                        window.highlight = highlight;
                        window.range = range;
                        window.elementsClass = elementsClass;
                        if (elementsClass.className == 'note-editable panel-body') {
                            elementsClass.style.direction = 'rtl';
                            return;
                        }
                        if (elementsClass.style.direction != 'rtl' && elementsClass.style.direction != 'ltr') {
                            const spn = document.createElement('div');
                            spn.innerHTML = getHTMLOfSelection();
                            spn.style.direction = 'rtl';
                            range.deleteContents();
                            range.insertNode(spn);
                        } else {
                            elementsClass.style.direction = 'rtl';
                        }
                        clearSelection();
                    },
                });
                // create jQuery object from button instance.
                const $rtl = button.render();
                return $rtl;
            });
        },
        ltr(context) {
            let selection;
            // ui has renders to build ui elements.
            const ui = $.summernote.ui;
            context.memo('button.ltr', () => {
                // create button
                const button = ui.button({
                    contents: '<i class="fa fa-caret-right"/><i class="fa fa-paragraph"/>',
                    tooltip: 'Change text direction to the left',
                    click() {
                        function clearSelection() {
                            if (document.selection) {
                                document.selection.empty();
                            } else if (window.getSelection) {
                                window.getSelection().removeAllRanges();
                            }
                        }

                        function getHTMLOfSelection() {
                            let range;
                            if (document.selection && document.selection.createRange) {
                                range = document.selection.createRange();
                                return range.htmlText;
                            } else if (window.getSelection) {
                                selection = window.getSelection();
                                if (selection.rangeCount > 0) {
                                    range = selection.getRangeAt(0);
                                    const clonedSelection = range.cloneContents();
                                    const div = document.createElement('div');
                                    div.appendChild(clonedSelection);
                                    return div.innerHTML;
                                }
                                return '';
                            }
                            return '';
                        }
                        const highlight = window.getSelection();
                        const range = highlight.getRangeAt(0);
                        const elementsClass = range.endContainer.parentElement;
                        if (elementsClass.className == 'note-editable panel-body') {
                            elementsClass.style.direction = 'ltr';
                            return;
                        }
                        if (elementsClass.style.direction != 'rtl' && elementsClass.style.direction != 'ltr') {
                            const spn = document.createElement('div');
                            spn.innerHTML = getHTMLOfSelection();
                            spn.style.direction = 'ltr';
                            range.deleteContents();
                            range.insertNode(spn);
                        } else {
                            elementsClass.style.direction = 'ltr';
                        }
                        clearSelection();
                    },
                });
                // create jQuery object from button instance.
                const $ltr = button.render();
                return $ltr;
            });
        },
    });
}));
